export default __webpack_public_path__ + "static/media/Be prepared for this.638ae369.mp4";